import * as yup from "yup";

export const schema = (t: (val: string) => string) => {
    const validation = {
        name: yup.string().required(t("cmn:val.required")),
        startDate: yup.date().required(t("cmn:val.required")),
        endDate: yup.date().required(t("cmn:val.required")),
        startTime: yup.date().required(t("cmn:val.required")),
        trainingYear: yup.string().required(t("cmn:val.required")),
        endTime: yup
            .date()
            .typeError(t("cmn:val.required"))
            .required(t("cmn:val.required"))
            .test(
                "isGreater",
                t("ent.Timesheet:endTime.val.greaterThanStart"),
                function (value) {
                    const { startTime } = this.parent;
                    if (!value || !startTime) return true;
                    const start = new Date(startTime);
                    const end = new Date(value);
                    if (isNaN(start.getTime()) || isNaN(end.getTime()))
                        return false;

                    return end > start;
                }
            ),
        capacity: yup
            .number()
            .typeError(t("cmn:val.required"))
            .required(t("cmn:val.required")),
    };
    return yup.object().shape({ ...validation });
};
